module.exports = __webpack_public_path__ + "static/media/b-sci-major-6_LR.264dc294.jpg";